import { createFileRoute } from "@tanstack/react-router";
import { QueueForm } from "./-component/queue-form";

export const Route = createFileRoute("/_dashboard/queues/new-queue")({
  component: NewQueueComponent,
  loader: async () => ({
    crumb: "New queue",
  }),
});

function NewQueueComponent() {
  return <QueueForm isEdit={false} queue={null} />;
}
